import { Component, forwardRef, EventEmitter, OnInit, Input, Output, ViewChild } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import {Message, OverlayPanel, SelectItem, ConfirmationService} from 'primeng/primeng';


import * as ent from '../../entities/index'
import * as serv from '../../services/index'

//components
import {MessageHandlerComponent} from '../../components/Controls/MessageHandler.component';
import {BlockComponent} from '../../components/Controls/Block.component';
import { ContactEditComponent } from '../Editors/ContactEdit.component';


//constants
import { Constants }         from '../../constants/Constants';
import { ContactGridComponent } from '../Grids/ContactGrid.component';
import { ContactFunctionDropdownComponent } from '../DomainData/ContactFunctionDropdown.component';


@Component({
  selector: 'my-payer-contact-selector',
  templateUrl: './PayerContactSelector.component.html'
})
export class PayerContactSelectorComponent implements OnInit {

    public msgs: Message[] = [];
    public userMessage: ent.UserMessage;
    contactDetailsForm: FormGroup;
    NoExistingPayerContacts: boolean;


    @ViewChild(MessageHandlerComponent) messageHandlerComponent: MessageHandlerComponent;
    @ViewChild(BlockComponent) blockComponent: BlockComponent;
    @ViewChild(ContactEditComponent) contactEditComponent: ContactEditComponent;
    @ViewChild(ContactGridComponent) contactGridComponent: ContactGridComponent;

    @Output() onOK = new EventEmitter();
    @Output() onCancel = new EventEmitter();


    public displayDialog: boolean;

    constructor(fb: FormBuilder, private domainDataService: serv.DomainDataService) {
        let group = {
            'updateNeeded': '',
            'firstName': '',
            'lastName': '',
            'contactPhoneNumber': '',
            'contactPhoneExtension': '',
            'secondaryContactName': '',
            'secondaryContactPhoneNumber': '',
            'contactPartnerNumber': '',
            'alternateContactPhoneNumber': '',
            'alternateContactPhoneExtension': '',
            'email': '',
            'contactFaxNumber': '',
            'contactDepartment': '',
            'contactFunction': '',
            'appliesToCustomer': '',
            'appliesToPayer' : '',
            'bypassLastNameRequired' : '',
            'copyOverallAccountPhoneNumber' : '',
            'copyOverallAccountEmail' : '',
        };

        this.contactDetailsForm = fb.group(group);


    }

    ngOnInit(): void {
        this.contactEditComponent.contactDepartmentDropdownComponent.load();
        this.contactEditComponent.contactFunctionDropdownComponent.load();
    }

    initializeContactInfo() {

        //this.NoExistingPayerContacts = false;
        this.contactEditComponent.contactInfo = new ent.ContactInfo();
        this.contactEditComponent.contactInfo.AppliesToPayer = true;
        this.contactEditComponent.contactInfo.CopyOverallAccountPhoneNumber = false;
        this.contactEditComponent.contactInfo.CopyOverallAccountEmail = false;
        this.contactEditComponent.contactInfo.ContactDepartment = {ID: Constants._NONE, Code: "", Name: ""};
        this.contactEditComponent.contactInfo.ContactFunction = {ID: Constants._NONE, Code: "", Name: ""};
        this.contactEditComponent.contactInfo.UpdateNeeded = {ID: Constants._NONE, Code: "", Name: ""};
        this.contactEditComponent.contactDepartmentDropdownComponent.value = Constants._NONE;
        if (this.contactEditComponent.setContactFunctionValueToDefault) {
            this.contactEditComponent.contactFunctionDropdownComponent.value = Constants._DEFAULT_CONTACT_FUNCTION_ID;    
            this.contactEditComponent.contactFunctionChange(Constants._DEFAULT_CONTACT_FUNCTION_ID);
        }
        else {
            this.contactEditComponent.contactFunctionDropdownComponent.value = Constants._NONE;
        }
        
        this.contactEditComponent.updateNeededDropdownComponent.value = Constants._NONE;
        this.contactEditComponent.displayDialog = true;
        if(this.contactEditComponent.hostedBy == Constants._HOSTED_BY_BILLING_ADDRESS){
            this.contactEditComponent.contactInfo.AppliesToPayer = true;
            this.contactEditComponent.contactInfo.AppliesToCustomer = false;
        } 
        if(this.contactEditComponent.hostedBy == Constants._HOSTED_BY_CONTACT_DETAILS){
            this.contactEditComponent.contactInfo.AppliesToCustomer = true;
            this.contactEditComponent.contactInfo.AppliesToPayer = false;
        }
    }

    onHide() {
        this.contactEditComponent.displayDialog = false;
    }

    updateContactInfos() {
        for (var rec of this.contactGridComponent.records) {
            let contactInfo = new ent.ContactInfo(rec);
            contactInfo.AppliesToDisplayValue = contactInfo.setAppliesToDisplayValue();
        }
        this.contactEditComponent.contactInfo.setAppliesToDisplayValue();
    }
    
    

    onOKClick(event: any) {
        this.updateContactInfos();
    
        this.onOK.emit();
    }

    onAddAndCloseClick(event: any ) {
        this.contactGridComponent.records.push(this.contactEditComponent.contactInfo);
        this.onOKClick(event);
    }

    onUpdateWithoutAddingClick(event: any) {
        this.updateContactInfos();
        this.onOK.emit();

    }

    onAddAndCreateAnotherClick(event: any) {
        
        this.contactGridComponent.records.push(this.contactEditComponent.contactInfo);

        this.initializeContactInfo();
    }

    onCancelClick(event: any) {
        this.onCancel.emit();
    }

}